const device = {}

function getDeviceName() {
  if (device.deviceName === undefined) {
    if (navigator.userAgent.match(/iPad/i)) {
      device.deviceName = 'ipad'
    } else if (navigator.userAgent.match(/iPhone/i)) {
      device.deviceName = 'iphone'
    } else {
      device.deviceName = 'unknown'
    }
  }

  return device.deviceName
}

function isIphone() {
  if (getDeviceName() !== 'iphone') {
    return false
  }

  return true
}

module.exports = {
  isIphone,
}
